/**
 * Login Button Component
 * SSO Login button that redirects to home after successful authentication
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LoginButton.css';

export const LoginButton: React.FC = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, loading } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      console.log('[LoginButton] Initiating SSO login...');
      
      // Initiate SSO login with home as return URL
      login('/');
      
      // The backend will handle redirect to SSO provider
      // After SSO authentication, backend redirects back to /
      // Then AuthContext will verify authentication and update state
    } catch (error) {
      console.error('[LoginButton] Login failed:', error);
      setIsLoading(false);
    }
  };

  // Don't show login button if already authenticated
  if (isAuthenticated) {
    return null;
  }

  return (
    <button
      onClick={handleLogin}
      disabled={isLoading || loading}
      className="login-button"
      aria-label="Login with SSO"
    >
      {isLoading || loading ? 'Logging in...' : 'Login with SSO'}
    </button>
  );
};
